module.exports = __webpack_public_path__ + "img/17 Spätauf Nageln (2).jpg";